import React, { useEffect } from 'react'
import { compose } from 'recompose'
import { useTheme, Grid, Typography, Button, Paper, Box, Link } from '@material-ui/core'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'
import LoginPagesWrapper from '../../../components/LoginPagesWrapper'
import Stepper from '../../../components/StepperV2'
import { makeStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import { getPatient, fetchCountriesByLocale, updatePatientFirstTouch, fetchTerms, getOwnerMFAState, showModal, hideModal, getCreatorInfo } from '../../../redux/actions'
import { countryListSelector, patientSelector, termsSelector, thirdPartyTermsSelector, ownerMFAStateSelector, creatorInfoSelector } from '../../../redux/selectors'
import { connect, useDispatch } from 'react-redux'
import FormCheckBox from '../../../components/FormCheckBox'
import { reduxForm, change, formValueSelector } from 'redux-form'
import Logo from '../../../assets/logo'
import { injectIntl } from 'react-intl'
import translations from '../../../utilties/languages/locales'
import * as cookies from '../../../utilties/cookies'
import locale2 from 'locale2'
import RegistrationPagesWrapper from '../../../components/RegistrationPagesWrapper'
import { getUser } from '../../../utilties/userUtilities'


const formName = 'welcome'


const TermViewDialog = ({ intl, title, term, termField }) => {
	const dispatch = useDispatch()

	const onAccept = () => {
		if (!!termField) {
			dispatch(change(formName, termField, true))
			dispatch(hideModal())
		}
	}

	const onCancel = () => {
		dispatch(hideModal())
	}

	return (
		<div
			data-testid="term-view-root"
			style={{
				width: '80vw'
			}}
		>
			<Grid
				data-testid="term-view-container"
				container
				direction="row"
				style={{
					padding: '40px'
				}}
			>
				<Grid
					item
					xs={12}
					style={{
						paddingBottom: '40px'
					}}
				>
					<Typography data-testid="term-view-title" variant='h2'>
						{title}
					</Typography>
				</Grid>
				<Grid
					item
					xs={12}
				>
					<div style={{
						height: '50vh',
						overflowY: 'scroll', paddingLeft: '25px', border: '1px solid rgba(0, 0, 0, 0.42)', padding: '10px'
						}}
					>
						<Typography data-testid="term-view-term" variant='caption'>
							<div dangerouslySetInnerHTML={{ __html: term }} />
						</Typography>
					</div>
				</Grid>
				<Grid
					item
					xs={12}
					style={{ paddingTop: '50px' }}
				>
					<Grid
						container
						direction="row"
						spacing={2}
						justifyContent="center"
					>
						{
							!!termField
							&& <Grid item>
								<Button
									data-testid="term-view-accept-button"
									variant='contained'
									color='primary'
									size='small'
									onClick={onAccept}
								>
									{intl.formatMessage({ id: 'app.acceptButton' })}
								</Button>
							</Grid>
						}
						<Grid item>
							<Button
								data-testid="term-view-cancel-button"
								variant='outlined'
								color='primary'
								size='small'
								onClick={onCancel}
							>
								{intl.formatMessage({ id: 'app.cancelButton' })}
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</div>
	)
}


const useStyles = makeStyles((theme) => ({
	gridStyle: {
	  padding: '6rem',
	  maxWidth: '479px',
	  width: '90%',
	  margin: '0 auto',
	  boxSizing: 'border-box',
	  display: 'flex',
	  flexDirection: 'column',
	  alignItems: 'center',
	  [theme.breakpoints.down('sm')]: {
		padding: '3rem 2rem',
	  }
	},
	avatar: {
		width: 23,
		height: 23,
		backgroundColor: '#7ab5e0',
		color: '#011020',
		fontSize: '17px',
		lineHeight: '23px'
	},

}))

const selector = formValueSelector(formName)

const getLocale = () => {
	let locale = 'en';
	let localeCookie = cookies.get('languageAbbreviation');

	if (localeCookie) {
		locale = localeCookie;
	}
	else if (locale2) {
		locale = locale2.substring(0, 5)
		if (locale !== 'en-GB') {
			locale = locale2.substring(0, 2)
		}
	}

	if (!translations[locale]) {
		locale = 'en'
	}

	return locale;
}

const Welcome = ({
	handleSubmit,
	intl,
	patient,
	loadCountries,
	loadPatient,
	updatePatient,
	internalTermsField,
	thirdPartyTermsField,
	loadTerms,
	internalTerms,
	thirdPartyTerms,
	ownerMFAState,
	loadOwnerMFAState,
    history,
	showTermDialog,
	getCreatorInfo,
	creatorInfo
}) => {
	const theme = useTheme()
	const user = getUser()
	
	const classes = useStyles()
	const onSubmitForm = (values) => {
		updatePatient({
			birthDate: values.birthDate,
			firstName: values.firstName,
			lastName: values.lastName,
			middleName: values.middleName,
			phoneNumber: values.phoneNumber,
			phoneCountryCode: values.phoneCountryCode,
			customPhoneCountryCode: values.customPhoneCountryCode,
			internalTerms: internalTerms,
			thirdPartyTerms: thirdPartyTerms
		})
	}

	useEffect(() => {
        loadCountries(getLocale())
		loadPatient()
        loadOwnerMFAState()
    }, [])

	useEffect(
		() => {
			if (!!user && !creatorInfo) {
				getCreatorInfo()
			}
		},
		[user]
	)

	useEffect(() => {
		if (patient) {
			loadTerms(patient.circleId, getLocale())
		}

	}, [patient && patient.circleId])

	return (
		<LoginPagesWrapper>
			<RegistrationPagesWrapper
				showCreatorInfoPanel={true}
			>
				<form
					data-testid="form-welcome"
					onSubmit={handleSubmit(onSubmitForm)}
					style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}
				>
					<Paper className={classes.gridStyle} elevation={2}>
						<Grid item style={{ paddingBottom: '20px' }} align='center'>
							<Logo />
						</Grid>
						<Grid item  style={{ width: '100%', paddingBottom: '20px' }}>
							<Typography data-testid="form-welcome-title" variant="subtitle1" style={{ fontWeight: '400', fontSize: '1.3em' }} align='center'>
								{intl.formatMessage({ id: 'app.welcome.almostReady.title' })}
							</Typography>
						</Grid>
						<Grid item style={{ width: '100%', paddingBottom: '40px' }}>
							<Typography data-testid="form-welcome-paragraph" variant='body1' align='center'>
								{intl.formatMessage({ id: 'app.welcome.agreements.paragraph' })}
							</Typography>
						</Grid>
						<Grid item style={{ width: '100%' }}>
							<Grid container style={{ display: 'block' }}>
								<Grid item>
									<Grid container spacing={2} direction='row' style={{ flexWrap: 'nowrap' }}>
										<Grid item>
											<Typography data-testid="if-terms-title" variant='h3'> {' '} {intl.formatMessage({ id: 'app.welcome.internalTermsLabel' })} </Typography>
										</Grid>
									</Grid>
								</Grid>
								{internalTerms && (
									<Grid item style={{ padding: '10px 0 25px' }}>
										<div style={{ minHeight: '200px', maxHeight: '200px', overflowY: 'scroll', paddingLeft: '25px', border: '1px solid rgba(0, 0, 0, 0.42)', padding: '10px' }}>
											<Typography data-testid="form-welcome-terms" variant='caption'>
												<div dangerouslySetInnerHTML={{ __html: internalTerms }} />
											</Typography>
										</div>
									</Grid>
								)}
								<Grid
									item
									xs={12}
									style={{ padding: '10px 8px', marginBottom: '15px' }}
								>
									<Grid
										container
										direction='row'
										spacing={2}
									>
										<Grid item xs={12}>
											<Typography data-testid="internal-terms-link" variant='body1'>
												<Box
													onClick={
														(e) => {
															e.preventDefault()
															showTermDialog(
																intl.formatMessage({ id: 'app.welcome.internalTermsLabel' }),
																internalTerms,
																intl,
																'internalTermsField'
															)
														}
													}
												>
													<Link href='#'>
														{intl.formatMessage({ id: 'app.termsSettings.readAll' })}
													</Link>
												</Box>
											</Typography>
										</Grid>
										<Grid item xs={12}>
											<FormCheckBox name='internalTermsField'
												data-testid="form-welcome-terms-checkbox"
												label={intl.formatMessage({ id: 'app.welcome.shareWithCommunity' })}
											/>
										</Grid>

									</Grid>
								</Grid>
								<Grid item>
									<Grid container spacing={2} direction='row' style={{ flexWrap: 'nowrap' }}>
										<Grid item>
											<Typography data-testid="thirdparty-label" variant='h3'>{' '} {intl.formatMessage({ id: 'app.welcome.thirdPartyTermsLabel' })} </Typography>
										</Grid>
									</Grid>
								</Grid>
								{thirdPartyTerms && (
									<Grid container spacing={2} style={{ display: 'block' }}>
										<Grid item style={{ borderLeft: '5px solid #transparent', paddingTop: '10px', paddingBottom: '25px' }}>
											<div style={{ minHeight: '200px', maxHeight: '200px', overflowY: 'scroll', paddingLeft: '25px', border: '1px solid rgba(0, 0, 0, 0.42)', padding: '10px' }}>
												<	Typography data-testid="thirdparty-terms-text" variant='caption'> <div dangerouslySetInnerHTML={{ __html: thirdPartyTerms }} /> </Typography>
											</div>
										</Grid>
									</Grid>
								)}
								<Grid
									item
									xs={12}
									style={{ padding: '10px 8px', marginBottom: '15px' }}
								>
									<Grid
										container
										direction='row'
										style={{ padding: '0 0 30px' }}
										spacing={2}
									>

										<Grid item xs={12}>
											<Typography data-testid="thirdparty-terms-link" variant='body1'>
												<Box
													onClick={
														(e) => {
															e.preventDefault()
															showTermDialog(
																intl.formatMessage({ id: 'app.welcome.thirdPartyTermsLabel' }),
																thirdPartyTerms,
																intl,
																'thirdPartyTermsField'
															)
														}
													}
												>
													<Link href='#'>
														{intl.formatMessage({ id: 'app.termsSettings.readAll' })}
													</Link>
												</Box>
											</Typography>
										</Grid>
										<Grid item xs={12}>
											<FormCheckBox name='thirdPartyTermsField' data-testid="thirdparty-checkbox"
												label={intl.formatMessage({ id: 'app.welcome.shareWithProfessional' })}
											/>
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
						<Grid item style={{ width: '100%' }} />
						<div className="stepper-register-wrapper stepper-register-wrapper-fullwidth">
						<div className="stepper-register-only-button">
								<Button
									data-testid="form-next-button"
									type='submit'
									variant='contained'
									color='primary'
									size='small'
									disabled={!(internalTermsField && thirdPartyTermsField)}
									endIcon={<KeyboardArrowRight />}
									style={{
										marginTop: '8px',
									}}
								>
									{intl.formatMessage({ id: 'app.termsSettings.buttonText' })}                                
								</Button>
							</div>
							<div className="stepper-register-step">
								<Stepper stepsCount={3 + (ownerMFAState ? 1 : 0)} selectedStep={3 + (ownerMFAState ? 1 : 0)} stepNumber={4}/>
							</div>
							{/* 
							<div className="stepper-register-back">
								{
									//<Button
									//	data-testid="form-back-button"
									//	variant='outlined'
									//	disabled={false}
									//	startIcon={<KeyboardArrowLeft />}
									//	onClick={() => history.goBack()}
									//>
									//	<Typography style={{ fontSize: '14px' }}>
									//		{intl.formatMessage({ id: 'app.general.previous' })}
									//	</Typography>
									//</Button>
								}
							</div>
							 */}
						</div>
					</Paper>
				</form>
			</RegistrationPagesWrapper>
		</LoginPagesWrapper>
	)
}

const mapStateToProps = (state, ownProps) => ({
	internalTerms: termsSelector(state),
	thirdPartyTerms: thirdPartyTermsSelector(state),
	patient: patientSelector(state),
	countries: countryListSelector(state),
	initialValues: patientSelector(state),
	firstName: selector(state, 'firstName'),
	lastName: selector(state, 'lastName'),
	countryId: selector(state, 'countryId'),
	phoneNumber: selector(state, 'phoneNumber'),
	dob: selector(state, 'birthDate'),
	internalTermsField: selector(state, 'internalTermsField'),
	thirdPartyTermsField: selector(state, 'thirdPartyTermsField'),
    ownerMFAState: ownerMFAStateSelector(state),
	creatorInfo: creatorInfoSelector(state)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
	change: (name, value) => dispatch(change(formName, name, value)),
	loadTerms: (circleId, language) => dispatch(fetchTerms(circleId, language)),
	loadPatient: () => dispatch(getPatient()),
	loadCountries: (locale) => dispatch(fetchCountriesByLocale(locale)),
	setCountry: (countryId) => dispatch(change(formName, 'countryId', countryId)),
    loadOwnerMFAState: () => dispatch(getOwnerMFAState()),
	getCreatorInfo: () => dispatch(getCreatorInfo()),
	updatePatient: (patient) =>
		dispatch(
			updatePatientFirstTouch(patient)
		),
	showTermDialog: (title, term, intl, termField) => dispatch(
		showModal(
			TermViewDialog,
			{
				title,
				term,
				intl,
				termField
			}
		)
	)
})

const enhance = compose(
	connect(mapStateToProps, mapDispatchToProps),
	injectIntl,
	reduxForm({
		form: formName,
		touchOnChange: true,
		touchOnBlur: true,
		enableReinitialize: true
	}),
	withRouter
)

export default enhance(Welcome)
